// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.department-detail-sidebar-people {
  display: flex;
  flex-direction: column;
  height: calc(100vh - var(--header-height) - var(--sidebar-header-height) - 120px);

  /* overflow-y: scroll; */
  padding-left: 1px;
}

  .department-detail-sidebar-people__button-group {
    display: flex;
    padding-bottom: 25px;
    width: 400px;
    justify-content: space-between;
  }

  .department-detail-sidebar-people__button-group-add-button {
      height: 32px;
      width: 180px;
    }

  .department-detail-sidebar-people__button-group-copy-button {
      height: 32px;
      width: 200px;
      margin-left: 40px;
    }

  .department-detail-sidebar-people-plus-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .department-detail-sidebar-people-times-icon {
    margin-left: 10px;
    width: 20px;
    height: 20px;
    color: red;
    cursor: pointer;
  }

  .department-detail-sidebar-people-trash-icon {
    width: 15px;
    height: 15px;
    cursor: pointer;
  }

  .department-detail-sidebar-people-trash-icon:hover {
      color: var(--color-green-8);
    }

  .department-detail-sidebar-people__input-field {
    margin-bottom: 10px;
    width: 100%;
    border-radius: 0;
  }

  .department-detail-sidebar-people__input-field-small {
      max-width: 65px;
      flex-grow: 0;
      margin-left: 6px;
    }

  .department-detail-sidebar-people__checkbox-group {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    align-self: stretch;
    justify-content: space-between;
    margin-bottom: 10px;
    width: 65px;
    padding-bottom: 3px;
    margin-left: 6px;
    border: 0;
  }

  .department-detail-sidebar-people-error-message {
    color: red;
  }
`, "",{"version":3,"sources":["webpack://./app/components/DepartmentDetailSidebar/components/DepartmentDetailSidebarPeople/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iFAAiF;;EAEjF,wBAAwB;EACxB,iBAAiB;AAwEnB;;EAtEE;IACE,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,8BAA8B;EAYhC;;EAVE;MACE,YAAY;MACZ,YAAY;IACd;;EAEA;MACE,YAAY;MACZ,YAAY;MACZ,iBAAiB;IACnB;;EAGF;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EAKjB;;EAHE;MACE,2BAA2B;IAC7B;;EAGF;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAOlB;;EALE;MACE,eAAe;MACf,YAAY;MACZ,gBAAgB;IAClB;;EAGF;IACE,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,UAAU;EACZ","sourcesContent":[".department-detail-sidebar-people {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - var(--header-height) - var(--sidebar-header-height) - 120px);\n\n  /* overflow-y: scroll; */\n  padding-left: 1px;\n\n  &__button-group {\n    display: flex;\n    padding-bottom: 25px;\n    width: 400px;\n    justify-content: space-between;\n\n    &-add-button {\n      height: 32px;\n      width: 180px;\n    }\n\n    &-copy-button {\n      height: 32px;\n      width: 200px;\n      margin-left: 40px;\n    }\n  }\n\n  &-plus-icon {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n  }\n\n  &-times-icon {\n    margin-left: 10px;\n    width: 20px;\n    height: 20px;\n    color: red;\n    cursor: pointer;\n  }\n\n  &-trash-icon {\n    width: 15px;\n    height: 15px;\n    cursor: pointer;\n\n    &:hover {\n      color: var(--color-green-8);\n    }\n  }\n\n  &__input-field {\n    margin-bottom: 10px;\n    width: 100%;\n    border-radius: 0;\n\n    &-small {\n      max-width: 65px;\n      flex-grow: 0;\n      margin-left: 6px;\n    }\n  }\n\n  &__checkbox-group {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    align-self: stretch;\n    justify-content: space-between;\n    margin-bottom: 10px;\n    width: 65px;\n    padding-bottom: 3px;\n    margin-left: 6px;\n    border: 0;\n  }\n\n  &-error-message {\n    color: red;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
